import { ViewModel, View } from "binder";
import { TabViewModel } from "../tab-viewModel";
import  { TabItemContainerView } from "./tabItemContainer-view"

export class TabItemContainerViewModel extends ViewModel{
    
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.tab = <TabViewModel>parentViewModel;
        this.isselected = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new TabItemContainerView();
    }
    public getTypeId(): string {
        return "VM-F684B6D9-E12E-49E6-8F8B-083599487619"
    }
    private tab:TabViewModel;
    public set element(v: ViewModel) { this._element = v; } public get element(): ViewModel { return this._element;} private _element: ViewModel;
    public set headerViewTemplate(v: Node) { this._headerViewTemplate = v; } public get headerViewTemplate(): Node { return this._headerViewTemplate;} private _headerViewTemplate: Node;
    public set isselected(v: boolean) { this._isselected = v; } public get isselected(): boolean { return this._isselected;} private _isselected: boolean;
    
    select() {
        this.tab.select(this);
    }

    
}
